/* eslint-disable no-nested-ternary */
import React from "react"
import { useSelector } from "react-redux"
import {
  getFilteredSortedGroupedSubmissions,
  getIsLoading,
  getVisibleColumns,
  paginationFormSubmissionLoadedCount,
  paginationFormSubmissionTotalCount,
} from "reduxSlices/formSubmissionTableSlice"
import LoadingIndicator from "shared/LoadingIndicator"
import PaginationLoadingStatus from "shared/PaginationLoadingStatus"
import SubmissionGrouping from "./SubmissionGrouping"
import AllSolutionGroupingsAreEmpty from "./AllSolutionGroupingsAreEmpty"

const SubmissionGroupingList = () => {
  const loading = useSelector(getIsLoading)
  const submissionGroups = useSelector(getFilteredSortedGroupedSubmissions)
  const visibleColumns = useSelector(getVisibleColumns)
  const loadedCount = useSelector(paginationFormSubmissionLoadedCount)
  const totalCount = useSelector(paginationFormSubmissionTotalCount)

  if (loading) {
    return (
      <div className="flex flex-col items-center mt-16">
        <LoadingIndicator textValue="Loading form submissions ..." />
        {
          !!loadedCount && !!totalCount && (
            <PaginationLoadingStatus loadedCount={loadedCount} totalCount={totalCount} />
          )
        }
      </div>
    )
  }

  const noSubmissionsToShow = Object.keys(submissionGroups).every((group) => (
    submissionGroups[group].length === 0
  ))

  if (noSubmissionsToShow) {
    return (
      <div className="mt-16">
        <AllSolutionGroupingsAreEmpty />
      </div>
    )
  }

  return (
    <div>
      {
        Object.entries(submissionGroups).map(([groupName, tableData]) => (
          <SubmissionGrouping
            key={groupName}
            columns={visibleColumns}
            groupName={groupName}
            tableData={tableData}
          />
        ))
      }
    </div>
  )
}

export default SubmissionGroupingList
